import type { ComponentProps } from "preact";
import { useEffect, useState } from "preact/hooks";

type Panel = typeof import("./MessageSecurity");
let panel: Promise<Panel> | null = null;

// Les règles et la liste des suffixes publics ne sont téléchargées qu’à l’ouverture.
export function MessageSecurityLazy(props: ComponentProps<Panel["MessageSecurity"]>) {
  const [mod, setMod] = useState<Panel | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let alive = true;
    (panel ??= import("./MessageSecurity"))
      .then((loaded) => { if (alive) setMod(loaded); })
      .catch(() => { panel = null; if (alive) setError(true); });
    return () => { alive = false; };
  }, []);
  if (mod) return <mod.MessageSecurity {...props} />;
  return <section class="message-security" id={"security-" + props.message.id} aria-label="Analyse de sécurité">
    <div class="security-heading"><h2>Analyse de sécurité</h2>
      <button class="chip" onClick={props.onClose} aria-label="Fermer l’analyse de sécurité">Fermer</button>
    </div>
    {error ? <p role="alert">Le panneau n’a pas pu être chargé. Actualisez la page pour réessayer.</p>
      : <p role="status">Chargement de l’analyse de sécurité…</p>}
  </section>;
}
